// src/hooks/useAPI.js
import { useState, useEffect, useCallback } from 'react';
import api from '../Services/api';

const useAPI = (endpoint) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 
  const fetchData = useCallback(async () => {
    // Jika endpoint tidak ada (null/undefined), jangan panggil API
    const candidateEndpoints = (Array.isArray(endpoint) ? endpoint : [endpoint]).filter(Boolean);

    if (!candidateEndpoints.length) {
      setLoading(false);
      setData([]);
      setError(null);
      return;
    }

    try {
      setLoading(true);
      let lastError = null;

      for (const targetEndpoint of candidateEndpoints) {
        try {
          console.log('Fetching data from:', targetEndpoint);

          const response = await api.get(targetEndpoint);
          console.log('API Response:', response.data);

          setData(response.data || []);
          setError(null);
          return;
        } catch (err) {
          lastError = err;

          if (err?.response?.status !== 404) {
            throw err;
          }
        }
      }

      throw lastError || new Error('Endpoint API tidak ditemukan');
    } catch (err) {
      console.error('Error in useAPI:', err);
      setError('Terjadi kesalahan saat mengambil data');
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { 
    data,
    loading, 
    error,
    refetch: fetchData
  };
};

export default useAPI;
